import React from "react"

import { useSearchParams } from "react-router-dom"

import Error from "../Error"

const ERROR_MESSAGES = {
  'missing-scope': [
    'You must "Select All" during Google authentication.',
  ],
}

export const AuthError = () => {
  const [searchParams] = useSearchParams();
  const errorKind = searchParams.get('msg');
  const errorMsgs = ERROR_MESSAGES[errorKind] || ["Something went wrong with authentication"];

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-3">
      {errorMsgs.map((errorMsg, i) => (
        <Error message={errorMsg} />
      ))}
      <Error message="Please try again or contact support@letteratlas.com" />
      <a href="/onboarding" className="mt-4 text-white-500 hover:underline">
        Go back
      </a>
    </div>
  )
}

export default AuthError
